export default "__VITE_ASSET__DBDAjAM7__"